import {
  CRS_COUNTRIES_NOT_SUPPORTED_BY_GRIFFIN,
  GRIFFIN_COUNTRIES_NOT_IN_CRS_LIST,
} from '@/lib/constants/crsCountries';

/**
 * TODO: [DETXOCOMPL-32] Remove this file once GriffinMetadataQuery is extended
 * This function builds the CRS country list from hardcoded constants as a temporary
 * solution. Once GriffinMetadataQuery provides the assigned country list directly,
 * this entire file can be deleted.
 *
 * @function buildCrsCountryList
 * @description Builds complete CRS country list by combining Griffin's supported countries
 * with unsupported countries from constants, mapped via content keys.
 * Filters out Griffin countries that are not in the CRS tax residency list.
 * @param {object} griffinMetadata - Griffin metadata from Redux store
 * @param {function} getContent - Content resolver function
 * @param {string} locale - Current locale (e.g., 'en_US')
 * @returns {Array} Array of territory objects { key, text, value }
 */
export const buildCrsCountryList = (griffinMetadata, getContent, locale) => {
  const allGriffinTerritories = griffinMetadata?.territories?.[locale] || [];

  // Filter out Griffin countries that are not in CRS tax residency list
  const filteredGriffinTerritories = allGriffinTerritories.filter(
    territory => !GRIFFIN_COUNTRIES_NOT_IN_CRS_LIST.includes(territory.key),
  );

  // Map unsupported codes to names using taxResidencyCountryList content
  const unsupportedTerritories = [];
  CRS_COUNTRIES_NOT_SUPPORTED_BY_GRIFFIN.forEach(code => {
    const countryName = getContent(`taxResidencyCountryList.${code}`);
    if (countryName && countryName !== `taxResidencyCountryList.${code}`) {
      unsupportedTerritories.push({
        key: code,
        text: countryName,
        value: code,
      });
    }
  });

  const allTerritories = [
    ...filteredGriffinTerritories,
    ...unsupportedTerritories,
  ];

  // Sort by country name
  const bcp47Locale = locale ? locale.replace('_', '-') : undefined;
  allTerritories.sort((a, b) => {
    const nameA = a.text || '';
    const nameB = b.text || '';
    try {
      return nameA.localeCompare(nameB, bcp47Locale);
    } catch {
      return nameA.localeCompare(nameB);
    }
  });

  return allTerritories;
};
